import React, { useRef, useEffect } from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

const STYLE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/map/style`;

export default function MiniLocationMap({ lat, lng, zoom = 13, height = 220, label }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (lat == null || lng == null || !containerRef.current || mapRef.current) return;
    const map = new maplibregl.Map({
      container: containerRef.current,
      style: STYLE_URL,
      center: [lng, lat],
      zoom,
      attributionControl: false,
    });
    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
    const el = document.createElement('div');
    el.style.cssText = 'width:22px;height:22px;border-radius:50% 50% 50% 0;background:#D97736;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 1px 4px rgba(0,0,0,.3)';
    new maplibregl.Marker({ element: el }).setLngLat([lng, lat]).addTo(map);
    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; };
  }, [lat, lng, zoom]);

  if (lat == null || lng == null) return null;
  return (
    <div data-testid="mini-location-map">
      {label && <p className="text-xs text-[#5C5C5C] mb-1">{label}</p>}
      <div ref={containerRef} style={{ height: `${height}px` }} className="w-full rounded-xl overflow-hidden border border-[#E5E4E0]" />
    </div>
  );
}
